import api from "../../index";

export const GetPaymentList = (data)=> api.post("payment-list",data)

export const VerifyStripePaymentApi = (data) => api.post('checkpaymentsession', data);
export const CreatePaymentSessionApi = (data) => api.post('create-session-url', data);
